import React, { useState, useContext, useEffect } from 'react';
import { Button, Box } from '@mui/material';
import { useNextProjectStep } from '../../../hooks/useNextProjectStep';
import ProjectInfoFields from '../ProjectInfoFields';
import { ProjectContext } from '../../../layouts/CreateProjectLayout';
import axios from 'axios';

const ProjectInfoStep = () => {
  const { project, setProject, canEditProject } = useContext(ProjectContext);
  const { goToNextStep } = useNextProjectStep();

  const [form, setForm] = useState({
    name: '',
    description: '',
  });

  // Sync context project to form when it loads
  useEffect(() => {
    if (project) {
      setForm({
        name: project.name || '',
        description: project.info.description || '',
      });
    }
  }, [project]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleNext = () => {
    goToNextStep();
  };

  const normalize = (val) => (val ?? '').trim();

  const isFormChanged = project && (
    normalize(form.name) !== normalize(project.name) ||
    normalize(form.description) !== normalize(project.info.description || "" )
  );

  const [saving, setSaving] = useState(false);


  const handleSave = async () => {
    setSaving(true);
    try {
      const payload = {
        name: form.name,
        info: {
          description: form.description,
        },
      };
      const response = await axios.patch(`/projects/${project.id}`, payload);
      console.log('Saved project:', response.data);
      setProject(response.data);

      // Update form with correct structure from response
      setForm({
        name: response.data.name || '',
        description: response.data.info?.description || '',
      });
    } catch (error) {
      console.error('Error saving project:', error);
    } finally {
      setSaving(false);
    }
  };


  return (
    <Box
      sx={{
        mx: 'auto',
        mt: 1,
        borderRadius: 4,
        width: { xs: '80%', sm: '70%' },
        display: 'flex',
        flexDirection: 'column',
        p: 1,
      }}
    >
      <ProjectInfoFields form={form} handleChange={handleChange} disabled={!canEditProject} />

      <Box
        sx={{
          padding: 2,
          width: '50%',
          mt: 4,
          display: 'flex',
          justifyContent: 'center',
          gap: 4,
        }}
      >
        <Button
          variant="outlined"
          disabled={!isFormChanged || saving || !canEditProject}
          onClick={handleSave}
          sx={{
            borderRadius: '12px',
            textTransform: 'none',
            fontSize: '16px',
            width: '120px',
            color: '#16a4b0',
            borderColor: '#16a4b0',
            '&:hover': { backgroundColor: '#f0f0f0', borderColor: '#16a4b0' },
          }}
        >
          Save
        </Button>

        <Button
          variant="contained"
          onClick={handleNext}
          sx={{
            borderRadius: '12px',
            backgroundColor: '#16a4b0',
            color: 'white',
            textTransform: 'none',
            fontSize: '16px',
            width: '120px',
            '&:hover': { backgroundColor: '#00707c' },
          }}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};

export default ProjectInfoStep;



